export enum timetablesUrls {
    timetables = "timetables",
    currentWeek = "timetables/weeks/current",
    numberOfWeeks = "timetables/weeks/count",
    downloadXls = "timetables/download/xls",
    downloadJson = "timetables/download/json",
    copy = "timetables/copy",
}